import React from 'react';

const CountryLabel = ({ flag, code, name }) => {

    return (
        <div className="flex flex-row p-1 gap-2">
            <div>{flag}</div>
            <div className="desc">
                {name}
            </div>
        </div>
    );
};

export default CountryLabel;
